<template>
  <div class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40" @click.self="$emit('close')">
    <div class="bg-white rounded-lg shadow-lg p-6 w-full max-w-md relative mx-4 flex flex-col items-center justify-center text-center">
      <button class="absolute top-2 right-2 text-gray-400 hover:text-gray-600 text-xl" @click="$emit('close')">
        <svg class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
      <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" fill="none">
        <path d="M21 3.5C17.5388 3.5 14.1554 4.52636 11.2775 6.44928C8.39967 8.37221 6.15665 11.1053 4.83212 14.303C3.50758 17.5007 3.16102 21.0194 3.83627 24.4141C4.51151 27.8087 6.17822 30.9269 8.62564 33.3744C11.0731 35.8218 14.1913 37.4885 17.5859 38.1637C20.9806 38.839 24.4993 38.4924 27.697 37.1679C30.8947 35.8433 33.6278 33.6003 35.5507 30.7225C37.4736 27.8446 38.5 24.4612 38.5 21C38.4949 16.3603 36.6495 11.912 33.3687 8.63126C30.088 5.35048 25.6397 3.5051 21 3.5ZM21 29.75C20.6539 29.75 20.3155 29.6474 20.0278 29.4551C19.74 29.2628 19.5157 28.9895 19.3832 28.6697C19.2508 28.3499 19.2161 27.9981 19.2836 27.6586C19.3512 27.3191 19.5178 27.0073 19.7626 26.7626C20.0073 26.5178 20.3191 26.3511 20.6586 26.2836C20.9981 26.2161 21.3499 26.2508 21.6697 26.3832C21.9895 26.5157 22.2628 26.74 22.4551 27.0277C22.6474 27.3155 22.75 27.6539 22.75 28C22.75 28.4641 22.5656 28.9092 22.2374 29.2374C21.9093 29.5656 21.4641 29.75 21 29.75ZM22.75 22.75C22.75 23.2141 22.5656 23.6592 22.2374 23.9874C21.9093 24.3156 21.4641 24.5 21 24.5C20.5359 24.5 20.0908 24.3156 19.7626 23.9874C19.4344 23.6592 19.25 23.2141 19.25 22.75V14C19.25 13.5359 19.4344 13.0907 19.7626 12.7626C20.0908 12.4344 20.5359 12.25 21 12.25C21.4641 12.25 21.9093 12.4344 22.2374 12.7626C22.5656 13.0907 22.75 13.5359 22.75 14V22.75Z" fill="#FF4265"/>
      </svg>
      <h2 class="text-lg font-bold mb-4 text-custom_gray">Compartir propiedad</h2>
      <p class="mb-4 text-custom_gray">Selecciona la opción por dónde quieras compartir esta propiedad</p>
      <div class="flex justify-center gap-6 mb-6">
        <!-- Link -->
        <div class="flex flex-col items-center">
          <button @click="handleCopyLink" class="group w-8 h-8 rounded-full text-tuin-100 border border-tuin-100 hover:bg-tuin-100 flex items-center justify-center mb-1">
            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
              <path d="M9.29199 3.74984L10.8753 2.1665C11.667 1.37484 13.2503 1.37484 14.042 2.1665L14.8337 2.95817C15.6253 3.74984 15.6253 5.33317 14.8337 6.12484L10.8753 10.0832C10.0837 10.8748 8.50033 10.8748 7.70866 10.0832M7.70866 13.2498L6.12533 14.8332C5.33366 15.6248 3.75033 15.6248 2.95866 14.8332L2.16699 14.0415C1.37533 13.2498 1.37533 11.6665 2.16699 10.8748L6.12533 6.9165C6.91699 6.12484 8.50033 6.12484 9.29199 6.9165" class="stroke-tuin-100 group-hover:stroke-white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
          <span class="text-xs text-custom_gray">Link</span>
        </div>
        <!-- WhatsApp -->
        <div class="flex flex-col items-center">
          <a :href="`https://wa.me/?text=${encodeURIComponent(slug_url)}`" target="_blank" @click="handleClick(propertyId, 8, 'Usuario compartio la propiedad vía Whastapp desde Asesores')"  class="group w-8 h-8 rounded-full text-tuin-100 border border-tuin-100 hover:bg-tuin-100 flex items-center justify-center mb-1">
            <svg xmlns="http://www.w3.org/2000/svg" width="19" height="18" viewBox="0 0 19 18" fill="none"><path d="M14.537 3.683A7.37 7.37 0 0 0 9.28 1.5c-4.095 0-7.433 3.338-7.433 7.433 0 1.312.345 2.587.99 3.712L1.787 16.5l3.938-1.035a7.4 7.4 0 0 0 3.555.907c4.095 0 7.432-3.337 7.432-7.432a7.4 7.4 0 0 0-2.175-5.257M9.28 15.113a6.2 6.2 0 0 1-3.15-.863l-.225-.135-2.34.615.622-2.28-.15-.232a6.2 6.2 0 0 1-.945-3.285 6.19 6.19 0 0 1 6.18-6.18c1.65 0 3.203.645 4.365 1.815a6.13 6.13 0 0 1 1.808 4.372c.015 3.405-2.76 6.173-6.165 6.173m3.39-4.62c-.188-.09-1.103-.54-1.268-.608-.172-.06-.292-.09-.42.09-.127.188-.48.607-.585.728-.105.127-.217.142-.405.045-.187-.09-.787-.293-1.492-.923-.555-.495-.923-1.102-1.035-1.29-.105-.187-.015-.285.082-.382.083-.083.188-.218.278-.323s.127-.187.187-.307c.06-.128.03-.233-.015-.323s-.42-1.005-.57-1.38c-.15-.36-.307-.315-.42-.322h-.36a.67.67 0 0 0-.495.232c-.165.188-.645.638-.645 1.553s.668 1.8.758 1.92c.09.127 1.312 2.002 3.172 2.805.443.195.788.307 1.058.39.442.142.847.12 1.17.075.36-.053 1.102-.45 1.252-.886.158-.434.158-.802.105-.884-.052-.083-.165-.12-.352-.21" class="fill-tuin-100 group-hover:fill-white"/></svg>
          </a>
          <span class="text-xs text-custom_gray">WhatsApp</span>
        </div>
        <!-- Facebook -->
        <div class="flex flex-col items-center">
          <a :href="`https://www.facebook.com/sharer/sharer.php?u=${slug_url}`" target="_blank" @click="handleClick(propertyId, 9, 'Usuario compartió la propiedad vía Facebook desde Asesores')" class="group w-8 h-8 rounded-full text-tuin-100 border border-tuin-100 hover:bg-tuin-100 flex items-center justify-center mb-1">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M8.009 17.6h3.2v-6.408h2.883l.317-3.184h-3.2V6.4a.8.8 0 0 1 .8-.8h2.4V2.4h-2.4a4 4 0 0 0-4 4v1.608h-1.6l-.317 3.184h1.917z" class="fill-tuin-100 group-hover:fill-white"/></svg>
          </a>
          <span class="text-xs text-custom_gray">Facebook</span>
        </div>
        <!-- X (Twitter) -->
        <div class="flex flex-col items-center">
          <a :href="`https://twitter.com/intent/tweet?text=${propertyName}&url=${slug_url}`" target="_blank" @click="handleClick(propertyId, 10, 'Usuario compartió la propiedad vía X desde Asesores')" class="group w-8 h-8 rounded-full text-tuin-100 border border-tuin-100 hover:bg-tuin-100 flex items-center justify-center mb-1">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><g clip-path="url(#a)"><mask id="b" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="1" y="0" width="15" height="16"><path d="M1.21.96h14.08v14.08H1.21z" fill="#fff"/></mask><g mask="url(#b)"><path d="M12.298 1.62h2.16L9.74 7.024l5.55 7.356h-4.345L7.54 9.92l-3.892 4.46H1.487L6.53 8.597 1.21 1.621h4.455L8.74 5.697zm-.76 11.465h1.197L5.012 2.848H3.728z" class="fill-tuin-100 group-hover:fill-white"/></g></g><defs><clipPath id="a"><path fill="#fff" d="M.57.32h15.36v15.36H.57z"/></clipPath></defs></svg>
          </a>
          <span class="text-xs text-custom_gray">X</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';
import axios from 'axios';

const props = defineProps({
  slug_url: { type: String, required: true },
  propertyId: { type: [String, Number], required: true },
  propertyName: { type: String, required: true },
  session: { type: Object, required: true },
});
const emit = defineEmits(['close', 'copy-link']);

async function callActionLog(property_id, type_action, detail) {
  let link = `${process.env.VUE_APP_API_BASE_URL}/event/add_log`;
  let param_analytics = {
    "property_id": property_id,
    "user_id": props.session.id,
    "activity_id": type_action,
    "description": detail,
  };

  let options = {
    headers: {
      "Content-Type": "application/json"
    },
  };

  try {
    const response = await axios.post(link, param_analytics, options);
    if (response.status == 200) {
      console.log(response);
    }
  } catch (error) {
    console.error("Error fetching data:", error);
  }
}

async function handleClick(property_id, action_id, message) {
  try {
    await callActionLog(property_id, action_id, message);
  } catch (error) {
    console.error("Error logging action:", error);
  }
}

function handleCopyLink() {
  const shareUrl = `${props.slug_url}`;
  navigator.clipboard.writeText(shareUrl)
    .then(() => {
      handleClick(props.propertyId, 45, 'Usuario compartio la propiedad vía Copiar link desde Asesores');
      emit('copy-link');
    })
    .catch(() => {
      console.error('No se pudo copiar el enlace.');
    });
}
</script> 